import IntraNews from './IntraNews';

export default IntraNews;